import { FirmsCodeFormErrorJSON } from '../models/firms-code-form';

export const formFirmsCodeErrors: FirmsCodeFormErrorJSON = {
    firmsCode: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'regex',
            message: 'Invalid firms code',
        },
    ],
};

export const formAWBSearchErrors = {
    mawb: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'invalid',
            message: 'The AWB is invalid, please review the format',
        },
    ],
};
